import React from "react";
import ITradingDetails from "./ITradingDetails";
import Big from "big.js";
import ToolTip from "@appComponents/ToolTip/ToolTip";
import ISPVDetails from "@market/interfaces/ISPVDetails";
import QuestionMark from "@appComponents/QuestionMark/QuestionMark";
import { MyLink } from "@features/utils/reactFunctions";
import { connect } from "react-redux";
import { TReducers } from "@features/reducers";
import { IFilteredTradesList } from "@appComponents/TradeHistory/ITradeHistory";
import CurrencyElement from "@appComponents/CurrencyElement/CurrencyElement";

import * as style from "./TradingDetailsStyle.module.scss";
const big = Big();

export const TradingDetails: React.FunctionComponent<ITradingDetails> = (
  props: ITradingDetails
) => {
  if (
    !props.companyDetails.trading_spv_id ||
    !props.companyDetails.trading_asset_id
  ) {
    return null;
  }

  const href = `/companies/${props.companyDetails.slug}/market/spvs/${props.companyDetails.trading_spv_id}/orders`;

  const link = props.userSignedIn ? href : `/users/sign_in?return_url=${href}`;
  const lastTrades = props.trades && props.trades.slice(0, 5);

  const price = getPrice(lastTrades);

  const performance =
    props.spv && props.spv.detailedCompanyAsset
      ? getPerformancePercentage(price, props.spv.detailedCompanyAsset)
      : undefined;

  return (
    <div className={style.details}>
      {!!price && (
        <section className={style.detailsSection}>
          <h5>
            Price&nbsp;
            <ToolTip text="The weighted average of the last 5 trades">
              <QuestionMark isSmall={true} />
            </ToolTip>
          </h5>
          <p>
            <CurrencyElement value={price} currency={"usd"} />
          </p>
        </section>
      )}
      {performance !== undefined && (
        <section className={style.detailsSection}>
          <h5>
            Performance&nbsp;
            <ToolTip text="An indication of price change between Price indicator and Initial share price">
              <QuestionMark isSmall={true} />
            </ToolTip>
          </h5>
          <p>{performance}</p>
        </section>
      )}
      <MyLink
        to={link}
        className={style.button}
        isReactLink={props.userSignedIn}
      >
        Trade
      </MyLink>
    </div>
  );
};

const getPerformancePercentage = (price: number, assetDetails: ISPVDetails) => {
  const initialSharePrice = Number(assetDetails.initial_share_price);
  if (price === 0 && initialSharePrice === 0) {
    return "0%";
  }

  if (initialSharePrice === 0) {
    return "+100%";
  }

  return `${Number(
    big(price)
      .sub(initialSharePrice)
      .div(initialSharePrice)
      .times(100)
      .toFixed(2)
  )}%`;
};

const getPrice = (lastTrades: IFilteredTradesList[]) => {
  if (lastTrades && lastTrades.length > 0) {
    let numberOfSharesSum = big(0);
    const valueSum = lastTrades.reduce((prev, current) => {
      numberOfSharesSum = big(numberOfSharesSum).add(current.number_of_shares);
      return big(prev).add(big(current.value));
    }, big(0));

    return Number(big(valueSum).div(numberOfSharesSum).toFixed(1));
  }

  return 0;
};

const mapStateToProps = (store: TReducers) => {
  return {
    trades: store.secondaryMarketReducer.tradesHistory,
    companyDetails: store.companyReducer.companyDetails,
    spv: store.secondaryMarketReducer.spvs
      ? store.secondaryMarketReducer.spvs.find(
          (el) => el.id === store.companyReducer.companyDetails.trading_spv_id
        )
      : store.secondaryMarketReducer.spvs,
  };
};

export default connect(mapStateToProps)(TradingDetails);
